var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0H0V16H16V0ZM8.32213 10.2303C8.32213 10.7323 8.46766 11.154 8.76104 11.4934L8.76335 11.491C9.05672 11.8303 9.51412 12 10.1401 12C10.6738 12 11.1889 11.8021 11.6856 11.4109C12.1822 11.0197 12.6212 10.2468 13 9.09691H12.3532C12.1684 9.56819 11.9836 9.91694 11.7988 10.1408C11.614 10.3647 11.3668 10.4778 11.0595 10.4778C10.8355 10.4778 10.6761 10.4212 10.5837 10.3057C10.4913 10.1926 10.4451 10.03 10.4451 9.82032C10.4451 9.64124 10.4774 9.39853 10.5444 9.08984C10.6114 8.78115 10.6853 8.46539 10.7685 8.14021C10.9002 7.60766 11.0041 7.15523 11.0757 6.78292C11.1473 6.41296 11.1843 6.07599 11.1843 5.77202C11.1843 5.17585 11.0295 4.73049 10.7223 4.43829C10.415 4.1461 9.99923 4 9.47716 4C8.79107 4 8.19045 4.29219 7.67762 4.87894L7.84625 4.06362H5.6309L4 11.9128H6.21535L7.26181 6.87482C7.38424 6.44595 7.54825 6.0972 7.75385 5.83093C7.95714 5.56465 8.19276 5.43034 8.46073 5.43034C8.83034 5.43034 9.01514 5.69897 9.01514 6.23152C9.01514 6.45066 8.97818 6.73814 8.90657 7.09396C8.83496 7.44978 8.75642 7.81031 8.67557 8.17555C8.65477 8.2486 8.6155 8.41591 8.56006 8.67747C8.50462 8.93903 8.44918 9.20766 8.39836 9.48571C8.34754 9.76141 8.32213 10.0112 8.32213 10.2303Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomNewIcon);
export default __webpack_public_path__ + "static/media/bottom-new-icon.18e1b42c31f163195f6cb2bdec18972e.svg";
export { ForwardRef as ReactComponent };